function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Select from '../Select.react';
var SelectPermissionGroup = function SelectPermissionGroup(_ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var cmsPermissionGroups = useSelector(function (s) {
    return s.app.constants.permissionGroups;
  });
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    arr = _useState2[0],
    setArr = _useState2[1];
  useEffect(function () {
    setArr(Object.keys(cmsPermissionGroups).map(function (x) {
      return {
        key: x,
        label: cmsPermissionGroups[x] || ''
      };
    }));
  }, [cmsPermissionGroups]);
  return /*#__PURE__*/React.createElement(Select, _extends({
    options: arr.sort(function (a, b) {
      return a.label.localeCompare(b.label);
    }).map(function (x) {
      return {
        sLabel: x.label,
        sValue: x.key
      };
    })
  }, rest));
};
export default SelectPermissionGroup;